export const initGA = (measurementId: string) => {
  console.log('Attempting to initialize GA:', measurementId);
  
  if (typeof window.gtag === 'function' && window.dataLayer) {
    console.log('GA already initialized.');
    return;
  }

  // Initialize dataLayer and gtag function BEFORE loading script
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  
  window.gtag('js', new Date());
  window.gtag('config', measurementId);

  // Create script tag for gtag.js
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.id = 'google-analytics-script'; // Added id for easier DOM inspection
  
  document.head.appendChild(script);
  
  console.log('GA Script appended to head.');
};

export const initClarity = (projectId: string) => {
  console.log('Attempting to initialize Clarity:', projectId);

  if (typeof window.clarity === 'function') {
    console.log('Clarity already initialized.');
    return;
  }

  // Clarity bootstrap snippet
  (function (c: any, l: any, a: string, r: string, i: string, t?: any, y?: any) {
    c[a] = c[a] || function () {
      (c[a].q = c[a].q || []).push(arguments);
    };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', projectId);

  console.log('Clarity Script appended to head.');
};

// Add types for window object
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    clarity: (...args: any[]) => void;
  }
}
